// ── Canonical city normalization data ─────────────────────────
// Single source of truth for city label→value mapping.
// Used by both the frontend and edge functions via the shared engine.

export interface CityEntry {
  value: string;
  label: string;
}

export const CITIES: CityEntry[] = [
  { value: 'tel-aviv', label: 'תל אביב' },
  { value: 'ramat-gan', label: 'רמת גן' },
  { value: 'givataim', label: 'גבעתיים' },
  { value: 'jerusalem', label: 'ירושלים' },
  { value: 'herzliya', label: 'הרצליה' },
  { value: 'rishon', label: 'ראשון לציון' },
  { value: 'bat-yam', label: 'בת-ים' },
  { value: 'shoam', label: 'שוהם' },
  { value: 'ofakim', label: 'אופקים' },
  { value: 'beer-sheva', label: 'באר שבע' },
  { value: 'haifa', label: 'חיפה' },
  { value: 'netanya', label: 'נתניה' },
  { value: 'eilat', label: 'אילת' },
  { value: 'ashdod', label: 'אשדוד' },
  { value: 'ashkelon', label: 'אשקלון' },
];

export function normalizeCityName(cityName: string | undefined): string | undefined {
  if (!cityName) return undefined;
  const cityObj = CITIES.find(c => c.label === cityName || c.value === cityName);
  return cityObj ? cityObj.value : cityName;
}

export function normalizeCityArray(cityNames: string[] | undefined): string[] {
  if (!cityNames || cityNames.length === 0) return [];
  return cityNames.map(city => normalizeCityName(city) || city);
}
